// currency cash flow minimum amounts
const DEFAULT_MIN_AMOUNT = 1

export const currencyMinAmountMap = {
  TWD: 1,
  HKD: 4,
  JPY: 50,
  MYR: 2,
  THB: 10,
  PHP: 1,
  SGD: 1
}

export function getCurrencyMinAmount (code) {
  if (!code) return DEFAULT_MIN_AMOUNT
  const key = code.toString().toUpperCase()
  return currencyMinAmountMap[key] || DEFAULT_MIN_AMOUNT
}
